export default __webpack_public_path__ + "static/media/012-walkie talkie.afd2bb27.svg";